<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新增管理</el-breadcrumb-item>
      <el-breadcrumb-item>销售管理</el-breadcrumb-item>
      <el-breadcrumb-item>预存管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.customername" @keyup.enter.native="clicksearch" placeholder="请输入客户名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.lianxifangshi" @keyup.enter.native="clicksearch" placeholder="请输入联系方式" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickSearch">查询</el-button>
<!--            <el-button type="primary" @click="clickexcel()">导出Excel</el-button>
            <TencentyunCosUploadExcel @change="changeTencentyunCosUploadExcel" ></TencentyunCosUploadExcel>
            注意：此处是覆盖导入 -->
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border :cell-style="{padding: '0'}" height="440">
          <el-table-column type="expand" min-width="1%">
            <template slot-scope="props">
              <el-table :data="props.row.Sublist" height="150" class="tableInner" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center',padding: '0' }">
                <el-table-column prop="Salesmanname" label="业务员" width="200"></el-table-column>
                <el-table-column prop="Amount" label="预存金额" width="200"></el-table-column>
                <el-table-column prop="Createtime" label="预存时间" width="200"></el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="Customername" label="客户名称" width="300"></el-table-column>
          <el-table-column prop="Lianxifangshi" label="联系方式" width="200"></el-table-column>
          <el-table-column prop="TotalPrepayment" label="总预存金额" width="120"></el-table-column>
          <el-table-column prop="TotalPayment" label="总支出金额" width="120"></el-table-column>
          <el-table-column prop="LeftPayment" label="预存金额结存" width="120"></el-table-column>
          <el-table-column prop="Amountmin" label="最低存款额" width="120"></el-table-column>
          <el-table-column prop="operation" label="操作" width="120">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickYuCun(scope.row)">新增预存金额</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 新增预存金额 start -->
        <el-dialog title="新增预存金额" :visible.sync="dialogFaHuo" width="600px">
          <el-form :model="modelYuCun" ref="addMechanismRef" label-width="150px">
            <el-form-item label="业务员" class="addAdminForm">
              <el-input v-model="modelYuCun.salesmanname" placeholder="请输入业务员"></el-input>
            </el-form-item>
            <el-form-item label="预存金额" class="addAdminForm">
              <el-input v-model="modelYuCun.amount" placeholder="请输入预存金额"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="apiAddErp6SalePrepayment">保存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 新增预存金额 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->
  </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadExcel,
  },
  name: 'MyErp6SalePrepayment',
  data () {
    return {
      activeName: 'first',
      keywords: {
        customername: '',
        lianxifangshi: ''
      },
      modelYuCun: {
        customerid: '',
        salesmanname: '',
        amount: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogFaHuo: false
    }
  },
  mounted () {
    this.apiGetErp6SalePrepaymentNum()
    this.apiGetErp6SalePrepaymentList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetErp6SalePrepaymentNum()
      this.apiGetErp6SalePrepaymentList()
    },
    changeTencentyunCosUploadExcel (url) {
      // this.apiExcelImportErp6SaleShip(url)
    },
    clickYuCun (row) {
      this.dialogFaHuo = true
      this.modelYuCun.customerid = row.Id
      this.modelYuCun.salesmanname = ''
      this.modelYuCun.amount = 0
    },
    clickReturn () {
      this.activeName = 'first'
    },
    clickexcel () {
      // this.apiExcelErp6SaleShip()
    },
    clickSearch () {
      this.selectedPageNo = 1
      this.apiGetErp6SalePrepaymentNum()
      this.apiGetErp6SalePrepaymentList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetErp6SalePrepaymentList()
    },
    apiGetErp6SalePrepaymentNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        customername: that.keywords.customername,
        lianxifangshi: that.keywords.lianxifangshi
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SalePrepaymentNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetErp6SalePrepaymentList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        customername: that.keywords.customername,
        lianxifangshi: that.keywords.lianxifangshi
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SalePrepaymentList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddErp6SalePrepayment: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        customerid: that.modelYuCun.customerid,
        salesmanname: that.modelYuCun.salesmanname,
        amount: that.modelYuCun.amount
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddErp6SalePrepayment, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6SalePrepaymentNum()
            that.apiGetErp6SalePrepaymentList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    // apiExcelErp6SaleShip: function () {
    //   var that = this
    //   var useriderp = localStorage.getItem('Useriderp')
    //   var timestamp = Date.parse(new Date()) / 1000
    //   var data = {
    //     os: 'erp',
    //     useriderp: useriderp,
    //     timestamp: timestamp,
    //     localfingerprint: Vue.prototype.FunGetLocalFingerprint()
    //   }
    //   // 加上签名
    //   data.sign = Vue.prototype.FunGetSignErp(data)
    //   axios.post(Vue.prototype.global.Url_ExcelErp6SaleShip, Qs.stringify(data))
    //     .then(function (response) {
    //       Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
    //         that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
    //           confirmButtonText: '确定',
    //           cancelButtonText: '取消',
    //           showCancelButton: true,
    //           type: 'warning'
    //         }).then(() => {
    //           that.$router.push({ path: '/FileManagementExcel' })
    //         })
    //       })
    //     })
    //     .catch(function (error) {
    //       Vue.prototype.FunLogError(error)
    //     })
    // },
    // apiExcelImportErp6SaleShip: function (url) {
    //   var that = this
    //   var useriderp = localStorage.getItem('Useriderp')
    //   var timestamp = Date.parse(new Date()) / 1000
    //   var data = {
    //     os: 'erp',
    //     useriderp: useriderp,
    //     timestamp: timestamp,
    //     localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
    //     fileurl: url
    //   }
    //   // 加上签名
    //   data.sign = Vue.prototype.FunGetSignErp(data)
    //   axios.post(Vue.prototype.global.Url_ExcelImportErp6SaleShip, Qs.stringify(data))
    //     .then(function (response) {
    //       Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
    //         that.apiGetErp6ProjectNameList()
    //       })
    //     })
    //     .catch(function (error) {
    //       Vue.prototype.FunLogError(error)
    //     })
    // }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.warntitle {
  margin-left: 65px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(127, 124, 126);
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

</style>
